import { numConvert, calculation } from "@/method";

export default function compute(data) {
    const listName = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    listName.forEach(name => {
        data[9][name] = data.reduce((a, b, i) => {
            if (i < 9) {
                a += numConvert(b[name]);
            }
            return a
        }, 0).toFixed(2);
    });

    data.forEach((item, i) => {
        if (i < 10) {
            data[i]['Total'] = listName.reduce((a, b) => {
                a += numConvert(item[b]);
                return a;
            }, 0).toFixed(2);
        }
    });

    [...listName, 'Total'].forEach(name => {
        data[11][name] = calculation(
            data[9][name],
            data[10][name],
            2
        );
    });

    return data;
}


// WEBPACK FOOTER //
// ./src/components/table/9.0/9-9/compute.js